module.exports = __webpack_public_path__ + "img/icon-christmas-4.49dfbe9c.svg";